import { render } from "./MobileGreenBox3.vue?vue&type=template&id=f43dff0a"
import script from "./MobileGreenBox3.vue?vue&type=script&lang=js"
export * from "./MobileGreenBox3.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tre/tre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__